import {post} from '../utils/ajaxHelper';

function getLocalizedPropertyMetadata({listingId, locale}) {
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;
    const variant = window && window.debugLog && window.debugLog.variant;
    const url = `/pdp/propertyMetadata`;
    return post(url, {listingId, locale, variant, requestMarker});
}

export default getLocalizedPropertyMetadata;
export {getLocalizedPropertyMetadata};
